import { Pill } from '@garnet/ui';
import type { CheckStateVM } from '../data/types.js';
import { checkStateLabel, pillTone } from '../data/shape.js';

/**
 * StatePill — renders a per-check assurance state (prototype vocabulary) on the assurance
 * spine: machine=jade, attestation=gold, flag=brick, else neutral. Carried by colour PLUS
 * label, never colour alone.
 */
export function StatePill({ state, label }: { state: CheckStateVM; label?: string }) {
  return (
    <Pill tone={pillTone(state)}>{label ?? checkStateLabel(state)}</Pill>
  );
}
